export const labelStyles = {
    color: "var(--Grey-Grey-90, #262626)",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
};

export const inputStyles = {
    height: "38px",
    borderRadius : "8px",
    border: "1px solid var(--Grey-30, #E2E2E2)"
};

export const adjustmentFlagOptions = [
    {label : 'Yes' , value : 'Y'},
    {label : 'No' , value : 'N'},
    {label : 'Expired' , value : 'E'},
]
